export default __webpack_public_path__ + "static/media/fa-brands-400.28d8b8fc.woff";